module.exports = __webpack_public_path__ + "static/media/gcsuns.ccd57da1.svg";